import { serviceRequest } from 'utils/http';
import { ReferralService, Protocol801ParticipationUpdateDto } from 'common/api';

export function updateReferralProtocol801ParticipationAPI(
  protocol801ParticipationDto: Protocol801ParticipationUpdateDto
) {
  return serviceRequest(() =>
    ReferralService.referralControllerAddProtocol801Participation(
      protocol801ParticipationDto
    )
  );
}
